<template>
  <div class="race-question">
    <modal name="editLuckyRunner" @before-close="onClose" class="editluckyRunner" :adaptive="true" :scrollable="true" height="auto" width="80%" maxWidth="500">
      <div style="padding: 20px;">
        <h3>Edit LuckyLiveRunner</h3>
        <div class="form-data-outer">
        <div class="form-data">
         
            <label>Who</label>
            <input v-model="luckyRunnerData.runnerName">
         
        </div>
        <div class="form-data">
         
            <label>Sent</label>
            <input v-model="luckyRunnerData.presentSentDate" placeholder="YYYY-MM-DD">
         
        </div>

        <div class="form-data">
         
            <label>What</label>
            <input v-model="luckyRunnerData.presentContent">
         
        </div>

        <div class="form-data">
         
            <label>Note</label>
            <textarea v-model="luckyRunnerData.note"></textarea>
         
        </div>

      <div class="saveBtn">
        <button class="btn btn--primary" v-on:click="Save()" style="float:none">Save</button>
      </div>

        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue"
import LuckyLiveRunnerService from "../../../services/luckyLiveRunner"
import { db } from "../../../firebase"
import DateField from '@/components/Forms/DateField'

export default {
  name: "edit-lucky-live-runner",
  data: () => ({
   luckyRunnerData:{
      "id": '',
      "runDate": "",
      "runName": "",
      "raceDateTime":"",
      "trainerName": "",
      "runStartTime": "",
      "runnerId": '',
      "runnerName": "",
      "presentSentDate": "",
      "presentContent": "",
      "note": ''
    }
  }),
  props: {
    runnerData: {},
    show: false
  },
  methods: {
    onClose() {
      // this.gift = ""
      this.$emit("closed", true)
    },
    openEditModal() {
      Object.assign(this.luckyRunnerData, this.runnerData.rowData)
      this.$modal.show('editLuckyRunner')
    },
    Save() {
      LuckyLiveRunnerService.updateLuckyLiveRunnerData(this.luckyRunnerData).then(response => {
        this.$emit('saved', response.data)
        this.$modal.hide('editLuckyRunner')
      }).catch(error => {
          console.log("err---",error) 
          this.$modal.hide('editLuckyRunner')
      })          
    }
  },
  created() {
    this.$watch("show", function(val) {})
  },

  watch: {
    show(oldVal, newVal) {
      if (this.show) {
        this.openEditModal()
      }
    }
  },
  components: {
    DateField
  }
}
</script>
<style>
.editluckyRunner .sweet-title {
    text-align: center;
    color: #423799;
}
.editluckyRunner .sweet-modal {
  border-radius: 30px;
  border: 2px solid #ccc;
}
/* .editluckyRunner .sweet-content-content label {
    width: 100%;
    display: inline-block;margin-bottom:20px;} */
.editluckyRunner .sweet-content-content input {
    width: 85%;
    border-radius: 15px;
    border: 1px solid #ccc;
    padding: 0px 15px;
    height: 45px;
    font-size: 20px;
}
.editluckyRunner .form-data-outer {
    padding: 0px 45px 0 45px;
}
.editluckyRunner .sweet-content-content textarea {
    width: 85%;
    border-radius: 15px;
    border: 1px solid #ccc;
    padding: 12px 15px;
    min-height:90px;
}
.errorMsg {
  padding: 10px;
  color: red;
}
.editluckyRunner .sweet-modal.is-alert .sweet-content{padding:0 5px;}
.editluckyRunner .sweet-content-content label {     
    float: left;
    width: 10%;
    margin-top: 11px;
    font-size: 18px;
    margin-right: 10px;
    color: #3e3c3c;
}
.editluckyRunner .saveBtn{
  text-align: center
}
.editluckyRunner .form-data {
    margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// EditLuckyLiveRunner.vue?447be1a6